import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconHelpOutline, IconWaves } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { AttributeItem } from '../../../../../components/PriceOverviewCard/components/Rooms/components/AttributeItem.js';
import { Flex, ParagraphMedium, ParagraphXSmall, Tooltip } from '../../../../../primitives/index.js';
import { qaId } from '../../../../../utils/index.js';
import { PRICE_OVERVIEW_QA_ID } from '../../../../../utils/qaId.js';
export const HelpTooltip = ({
  room,
  index
}) => {
  const {
    t
  } = useTranslation('priceOverviewCard');
  return _jsx(Tooltip, {
    tooltipText: room.type,
    content: _jsxs(Flex, {
      gap: "4px",
      "data-testid": qaId(PRICE_OVERVIEW_QA_ID, 'tooltip-content'),
      children: [_jsxs(ParagraphMedium, {
        "data-testid": qaId(PRICE_OVERVIEW_QA_ID, 'tooltip-content-room-type'),
        children: [t('room', {
          index: index + 1
        }), ": ", room.type]
      }), _jsx(ParagraphXSmall, {
        color: "contentSecondary",
        "data-testid": qaId(PRICE_OVERVIEW_QA_ID, 'tooltip-content-room-type-long'),
        children: room.description
      }), room.oceanViewInfo && _jsxs(AttributeItem, {
        "data-testid": qaId(PRICE_OVERVIEW_QA_ID, `tooltip-content-room-sea-view-attribute`),
        children: [_jsx(IconWaves, {}), room.oceanViewInfo]
      }), _jsxs(AttributeItem, {
        "data-testid": qaId(PRICE_OVERVIEW_QA_ID, `tooltip-content-board-type-attribute`),
        children: [room.boardType.icon, room.boardType.name]
      }), room.attributes?.map((att, index_) => _jsxs(AttributeItem, {
        "data-testid": qaId(PRICE_OVERVIEW_QA_ID, `tooltip-content-room-alternative-attribute`),
        children: [att.icon, att.name]
      }, index_))]
    }),
    children: _jsx(IconHelpOutline, {
      tabIndex: 0,
      fontScale: "small"
    })
  });
};